import {
  UPDATE_VALID_FORM_DATA,
  UPDATE_FROM_GETDATA,
  ADD_BENEFIT_ITEM,
} from "../actions"

// Develop note
// Now the initial state is left in pristine conditions and the resulting state is just a copy of the initial state. Remember two key points for avoiding mutations in Redux:
// --use concat(), slice(), or the spread operator for arrays
// --use Object.assign() or object spread of objects

const initialClaimData = {
  claimAttributeModel: {
    UpStatus: "",
    ContractClass: "",
    ContractType: "",
    PurchaseDt: "",
  },
  claimFireDetail: {
    policyNumber: "",
    hdbReferenceNo: "",

    claimantName: "",
    claimantNricNumber: "",
    claimantUEN: "",
    residentialAddress: "",
    postalCode: "",
    claimantEmail: "",
    claimantMobile: "",
    unitNo: "",
    occupation: "",
    otherOccupation: "",

    dateLastSeen: "",
    timeLastSeen: "00:00",
    dateDiscovery: "",
    lossDetail: "",
    soleOwner: false,
    ownerName: "",
    ownerAddress: "",
    onLoan: false,
    financeName: "",
    financeAddress: "",
    otherInsurance: false,
    otherInsuranceName: "",
    otherInsuranceAddress: "",
    otherInsuranceType: "",
    otherInsuranceRefNo: "",
    otherInsuranceSumInsured: 0,
    lossBefore: false,
    claimOtherInsurance: false,
    claimInsuranceName: "",
    claimInsuranceDate: "",
    claimInsuranceDetail: "",
    claimInsuranceAmount: 0,
    
    nameOfStation: "",
    reportDate: "",
    reportTime: "",

    claimAmount: 0,

    declaration: false,
    sourceSystem: "Web",
    planPeriodFrom: "",
    planPeriodTo: "",
  },
}

const claimDataReducer = (state = initialClaimData, action) => {
  let targetModal = action.targetModal

  switch (action.type) {
    case UPDATE_VALID_FORM_DATA:
      return {
        ...state,
        [targetModal]: {
          ...state[targetModal],
          ...action.newData,
        },
      }

    case UPDATE_FROM_GETDATA:
      let claimPADetailProperty = "claimFireDetail"
      return {
        ...state,
        [claimPADetailProperty]: {
          ...state[claimPADetailProperty],
          [targetModal]: action.newData,
        },
      }

    case ADD_BENEFIT_ITEM:
      return {
        ...state,
        [targetModal]: action.newItemList,
      }
    default:
      return state
  }
}

export default claimDataReducer
